var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSleepIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6421 25.49V24.776H7.37806V25.49H11.7601L7.28006 31.286V32H12.7401V31.286H8.17606L12.6421 25.49Z",
    fill: "#535C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3969 16.63V15.712H17.6289V16.63H23.2629L17.5029 24.082V25H24.5229V24.082H18.6549L24.3969 16.63Z",
    fill: "#535C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1518 7.77V6.648H2.87981V7.77H9.76581L2.72581 16.878V18H11.3058V16.878H4.13381L11.1518 7.77Z",
    fill: "#535C5C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSleepIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAyOCAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjY0MjEgMjUuNDlWMjQuNzc2SDcuMzc4MDZWMjUuNDlIMTEuNzYwMUw3LjI4MDA2IDMxLjI4NlYzMkgxMi43NDAxVjMxLjI4Nkg4LjE3NjA2TDEyLjY0MjEgMjUuNDlaIiBmaWxsPSIjNTM1QzVDIi8+CjxwYXRoIGQ9Ik0yNC4zOTY5IDE2LjYzVjE1LjcxMkgxNy42Mjg5VjE2LjYzSDIzLjI2MjlMMTcuNTAyOSAyNC4wODJWMjVIMjQuNTIyOVYyNC4wODJIMTguNjU0OUwyNC4zOTY5IDE2LjYzWiIgZmlsbD0iIzUzNUM1QyIvPgo8cGF0aCBkPSJNMTEuMTUxOCA3Ljc3VjYuNjQ4SDIuODc5ODFWNy43N0g5Ljc2NTgxTDIuNzI1ODEgMTYuODc4VjE4SDExLjMwNThWMTYuODc4SDQuMTMzODFMMTEuMTUxOCA3Ljc3WiIgZmlsbD0iIzUzNUM1QyIvPgo8L3N2Zz4K";